<template>
  <div class="wrap">
    <div v-if="$sessionStorageUtil.get('member_types') != 0">
      <div class="vip-persons-info">
        <div class="vip-person-info-head">
          <h1 class="edit-phone-h1">输入登陆密码</h1>
          <div class="pw-nav">
            <i>1.验证身份</i>>
            <p>2.验证新手机号</p>
          </div>
        </div>
        <div class="vip-person-info-center">
          <fy-form :model="form_info" :rules="rules" ref="form" v-if="!isInit">
            <div class="pw-inputs">
              <span>密码：</span>
              <fy-form-item :prop="fields.passwd.field_enname">
                <fy-input
                  :placeholder="fields.passwd.field_placeholder"
                  style="width:300px;"
                  type="password"
                  v-model.trim="form_info.passwd"
                ></fy-input>
              </fy-form-item>
            </div>
          </fy-form>
          <div class="phone-submit">
            <a @click="$pushByName('memberInfo')" class="phone-submitBtn b2">返回</a>
            <a @click="validatePasswd()" class="phone-submitBtn" href="javascript:void(0);">下一步</a>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="vip-persons-info">
        <div class="vip-person-info-head">
          <h1 class="edit-phone-h1">输入手机验证码</h1>
          <div class="pw-nav">
            <i>1.验证身份</i>>
            <p>2.验证新手机号</p>
          </div>
        </div>
        <div class="phone-upd">
          <fy-form
            :model="sms_param"
            :rules="rules"
            class="fy-form-login fy-form-phone"
            ref="form_sms"
            v-if="!isInit"
          >
            <fy-form-item
              :inner_width="'100%'"
              :is_inline="true"
              :prop="fields.username.field_enname"
              :width="'60%'"
            >
              <fy-input
                :placeholder="fields.username.field_placeholder"
                :readonly="true"
                class="fy-input-phone"
                style="background-color: #fff;"
                type="text"
                v-model.trim="sms_param.username"
              >
                <img alt src="@/assets/images/html/login_phone_03.png">
              </fy-input>
            </fy-form-item>
            <div class="form-item-btn-div">
              <input
                @click="sendCode"
                class="form-item-btn"
                id="send_code"
                name="code"
                style="height:65px; line-height:20px;"
                type="button"
                value="发送验证码"
              >
            </div>
            <fy-form-item :inner_width="'100%'" :prop="fields.code.field_enname">
              <fy-input
                :placeholder="fields.code.field_placeholder"
                type="text"
                v-model.trim="sms_param.code"
              >
                <img alt class="email-img" src="@/assets/images/html/notice_03.png">
              </fy-input>
            </fy-form-item>
          </fy-form>
        </div>
        <div class="phone-submit">
          <a @click="$pushByName('memberInfo')" class="phone-submitBtn b2">返回</a>
          <a @click="validateMobile()" class="phone-submitBtn" href="javascript:void(0);">下一步</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import smsCode from '@/api/smsCode'
export default {
  name: 'EditPhone',
  componentName: 'EditPhone',
  data () {
    return {
      form_info: {
        passwd: '',
        username: this.$sessionStorageUtil.get('username'),
      },
      url: 'member/by_username_and_passwd',
      validate_mobile_url: 'member/validate_mobile/',
      send_code_url: 'sms_check_code/send_verify_phone_sms_check_code/',
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      fields: {},
      rules: {},
      sms_param: {
        code: '',
        username: this.$sessionStorageUtil.get('username'),
      },
    }
  },
  created () {
    this.$pageField.init(this, 'fields', 'login').then(res => {
      this.isInit = false //异步加载完成后设置为true
    })
  },
  methods: {
    sendCode (event) {
      const el = event.currentTarget
      this.$refs.form_sms.validateField('username', (message, invalidFields) => {
        if (message) {
          this.$msg(message, 'error')
        } else {
          let param = smsCode.butResendCountdown(el)
          this.$myPost(this.send_code_url + this.sms_param.username)
            .then(res => {
              const rcode = res.response.data.rcode
              if (rcode == 0) {
                this.$msg('短信验证码发送成功', 'success', 1000);
              } else {
                smsCode.butReset(el, param)
                this.$msg(res.response.data.messages[0].msg, 'info', 1000);
              }
            })
            .catch(err => {
              smsCode.butReset(el, param)
              this.$msg('[' + err.status + ']' + err.message, 'error')
            })
        }
      })
    },
    validatePasswd () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.$myGet(this.url, this.form_info).then(res => {
            const rcode = res.response.data.rcode
            if (rcode == 0) {
              this.$sessionStorageUtil.set('pwd', this.form_info.passwd, 60 * 10)
              this.$sessionStorageUtil.nextMsgSuccess('身份验证通过!')
              this.$pushByName('editPhone2')
            } else {
              this.$msg(
                res.response.data.messages[0].msg, 'error'
              )
            }
          }).catch(err => {
            this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
          })
        } else {
          this.$msg(invalidFields[0].message, 'error')
        }
      })
    },
    validateMobile () {
      this.$refs.form_sms.validate((valid, invalidFields) => {
        if (valid) {
          this.$myGet(this.validate_mobile_url + this.sms_param.username + '/' + this.sms_param.code)
            .then(res => {
              const rcode = res.response.data.rcode
              if (rcode == 0) {
                this.$sessionStorageUtil.set('validate_mobile_code', this.sms_param.code, 60 * 10)
                this.$sessionStorageUtil.nextMsgSuccess('身份验证通过!')
                this.$pushByName('editPhone2')
              } else {
                this.$msg(
                  res.response.data.messages[0].msg, 'error'
                )
              }
            })
            .catch(err => {
              this.$msg('[' + err.status + ']' + err.msg, 'error')
            })
        } else {
          this.$msg(invalidFields[0].message, 'error')
        }
      })
    }
  }
}
</script>
<style scoped>
@import '../../../assets/css/pages/customer/memberInfo.css';
</style>



// WEBPACK FOOTER //
// src/pages/customer/p_center/editPhone.vue